<template>
  <v-container v-if="!review">
    <div class="text-h4">What type of power outlet does your cabinet need?</div>
    <v-radio-group
      v-model="product.power_outlet_type[nth]"
    >
      <template v-slot:label>
        <div>
          {{ outletLabel }}
          <p>
            If you are unfamiliar with the outlet type codes,
            refer to this diagram:
            <a target="_blank" :href="`${publicPath}img/outlet-types.jpg`">Power Outlet Diagram</a>
          </p>
        </div>
      </template>
      <v-radio
        v-for="type in outletTypes"
        :key="type.value"
        :value="type.value"
      >
        <template v-slot:label>
          <div><b>{{ type.value }}</b> {{ type.label }}</div>
        </template>
      </v-radio>
    </v-radio-group>
  </v-container>
  <div v-else>
    <ReviewItem
      label="What type of power outlet does your cabinet need?"
      :value="product.power_outlet_type[reviewNth]"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import ReviewItem from '@/components/ReviewItem.vue';

export default {
  name: 'OutletType',
  props: {
    review: {
      required: false,
      type: Boolean,
    },
    id: {
      required: false,
      type: String,
    },
  },
  methods: {
    ...mapActions(['updateStoreFormData', 'syncFormData']),
    // CHANGE 'power_outlet_type' TO `power_outlet_type_${product.addons.nth}` OR WHATEVER
    /* setOutletAnswer(newVal) {
      this.updateStoreFormData({
        data: newVal,
        main: this.getProductIdSelected,
        sub: `power_outlet_type`,
      });
    }, */
    sync() {
      this.syncFormData({
        mainKey: this.getProductIdSelected,
        data: _.cloneDeep(this.product),
      });
    },
    getOutletType() {
      return this.getProductInfo().power_outlet_type;
    },
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      outletLabel: `
        To assist with timely and accurate installation of the power outlet type to your cabinet. Please tell us what type of outlet you need for your servers.
      `,
      outletTypes: [],
      nth: null,
      reviewNth: null,
      product: {},
      nonPowers: 0,
    };
  },
  created() {
    this.product = _.cloneDeep(this.getProductInfo());
    if (this.product.power_outlet_type == null) {
      this.$set(this.product, 'power_outlet_type', []);
    }
  },
  mounted() {
    if (this.getTabs.sub === 'review') {
      this.reviewNth = this.id.charAt(this.id.length - 1);
    }

    const tab = this.getTabs.sub;
    this.nth = parseInt(tab.charAt(tab.length - 1), 10);

    if (tab !== 'review') {
      this.getProductSelected.addons.forEach((addon) => {
        if (addon.item_code === "power" && addon.nth === this.nth) {
          addon.circuit_types.forEach((type) => {
            this.outletTypes.push({
              value: type.outlet_type,
              label: type.description,
            });
          });
        }
      });
    }
    this.outletTypes.push({
      value: "Unknown",
      label: "I Don't Know/None of These Options Work",
    });
  },
  computed: {
    ...mapGetters(['getProductIdSelected', 'getProductInfo', 'getProductSelected', 'getTabs']),
    currentTab() {
      return this.$store.state.currentSubTab;
    },
  },
  watch: {
    currentTab(tab) {
      this.nth = parseInt(tab.charAt(tab.length - 1), 10);
      const newTypes = [];

      this.getProductSelected.addons.forEach((addon) => {
        if (addon.item_code === "power" && addon.nth === this.nth) {
          addon.circuit_types.forEach((type) => {
            newTypes.push({
              value: type.outlet_type,
              label: type.description,
            });
          });
        }
      });

      newTypes.push({
        value: "Unknown",
        label: "Unknown/None of These Options Work",
      });
      this.outletTypes = newTypes;
      // this.product = _.cloneDeep(this.getProductInfo());
    },
    product: {
      deep: true,
      handler() {
        this.sync();
      },
    },
  },
  components: {
    ReviewItem,
  },
};
</script>
